import { MoreVertical } from "lucide-react";
import { useEffect, useRef, useState } from "react";

type Props = {
  onDisconnect: () => void;
  onChangePaymentToken?: () => void;
  iconSize?: "sm" | "md";
};

export function DisconnectWalletButton({
  onDisconnect,
  onChangePaymentToken,
  iconSize = "md",
}: Props) {
  const [showDisconnectMenu, setShowDisconnectMenu] = useState(false);
  const menuRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (menuRef.current && !menuRef.current.contains(event.target as Node)) {
        setShowDisconnectMenu(false);
      }
    };

    if (showDisconnectMenu) {
      document.addEventListener("mousedown", handleClickOutside);
      return () =>
        document.removeEventListener("mousedown", handleClickOutside);
    }
  }, [showDisconnectMenu]);

  const iconClasses = iconSize === "sm" ? "h-5 w-5" : "h-6 w-6";
  const buttonClasses =
    iconSize === "sm"
      ? "flex items-center justify-center rounded-md p-1 hover:bg-[--color-background-secondary] hover:bg-opacity-50 transition-all"
      : "flex items-center justify-center py-2.5 h-full hover:opacity-70 transition-opacity";

  return (
    <div className="relative" ref={menuRef}>
      <button
        onClick={(e) => {
          e.stopPropagation();
          setShowDisconnectMenu(!showDisconnectMenu);
        }}
        className={buttonClasses}
      >
        <MoreVertical
          className={`${iconClasses} text-[--color-text-secondary]`}
        />
      </button>
      {showDisconnectMenu && (
        <div className="absolute right-full mr-1 top-1/2 -translate-y-1/2 bg-[--color-modal-background] border border-[--color-background-secondary] rounded-lg shadow-lg z-50 overflow-hidden">
          {onChangePaymentToken && (
            <button
              onClick={(e) => {
                e.stopPropagation();
                setShowDisconnectMenu(false);
                onChangePaymentToken();
              }}
              className="py-2 px-4 text-xs text-[--color-text-primary] hover:bg-[--color-background-secondary] transition-colors whitespace-nowrap w-full text-left"
            >
              Switch token
            </button>
          )}
          <button
            onClick={(e) => {
              e.stopPropagation();
              setShowDisconnectMenu(false);
              onDisconnect();
            }}
            className="py-2 px-4 text-xs text-red-400 hover:bg-[--color-background-secondary] transition-colors whitespace-nowrap w-full text-left"
          >
            Disconnect
          </button>
        </div>
      )}
    </div>
  );
}
